/*
 * @Author: Teemo Ding
 * @Date: 2021-08-31 12:35:31
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-31 16:56:34
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/CustomerDBGetter/slice.ts
 */
import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { request_CustomerDatabaseName } from 'src/request/customer/database';
import { EnumReducers } from 'src/store/constants';
export const fetchDatabase = createAsyncThunk(
  'fetchDatabase',
  async (data: { databaseUuid: string }) => {
    const { databaseUuid } = data;

    const response = await request_CustomerDatabaseName(databaseUuid);
    return response;
  },
);

const target = (state) => {
  return state[EnumReducers.currentDatabase];
};

const defaultData = {
  databaseUuid: null,
  databaseName: '',
};

const currentDatabase = createSlice({
  name: 'currentDatabase',
  initialState: defaultData,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDatabase.fulfilled, (state, action) => {
      state.databaseName = action.payload;
    });
  },
});

const getCurrentDatabase = () => {
  return createSelector(
    (state: any) => {
      return target(state);
    },
    (state) => {
      return state;
    },
  );
};

const getIsCurrentDatabase = (uuid) => {
  return createSelector(
    (state: any) => {
      return (target(state) || {}).uuid || '';
    },
    (_uuid) => {
      return _uuid === uuid;
    },
  );
};

export { getCurrentDatabase, getIsCurrentDatabase };
export const {
  //   resetData,
  //   onButtonTextChange,
  //   onCollapseOpen,
  //   onEmptyStateSetting,
  //   onErrorChange,
  //   onFeaturedProductChange,
  //   validation,
  //   onNoticeBoardChange,
} = currentDatabase.actions;

export default currentDatabase.reducer;
